import { createRouter, createWebHistory } from 'vue-router'
import { disconnectSocket }               from '@/plugins/SocketIOPlugin'
import store                              from '@/store'

// import SettingsService from '@/services/SettingsService'

const routes = [
  {
    path: '/',
    meta: {
      layout: 'Main'
    },
    name: 'home',
    component: () => import('../views/SitesView')
  },

  {
    path: '/sites_:siteKey',
    name: 'sites_item',
    meta: {
      layout: 'Main'
    },
    component: () => import('../views/SitesItemView')
  },

  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'Start'
    },
    component: () => import('../views/LoginView')
  },

  {
    path: '/account',
    name: 'account',
    meta: {
      layout: 'Main'
    },
    component: () => import('../views/AccountView')
  },

  {
    path: '/settings',
    name: 'settings',
    meta: {
      layout: 'Main'
    },
    component: () => import('../views/SettingsView')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})



router.beforeEach(async (to, from, next) => {
  store.state.preloader = true

  if(store.state.user.isLoggedIn && to.query.account === 'logout') {
    next({ name: 'login', query: { account: 'logout_end' } })
  } else {
    if(!store.state.user.isLoggedIn && (from.name !=='login' && to.name !== 'login')) {
      next({ name: 'login' })
      localStorage.removeItem('token')
      store.state.preloader = false
    } else {
      try {
        next()
      } catch(error) {
        next({ name: 'home' })
      } finally {
        store.state.preloader = false
      }
    }
  }
})

export default router
